import { Table } from '@tanstack/react-table';
import { Virtualizer } from '@tanstack/virtual-core';
import { RefObject } from 'react';
import { createStore, StoreData } from '../Store';
import { FilterOptions } from './renderers/WithFilterOptions';

export interface TableContextValue<RowData = any> extends StoreData {
  id: string;
  table: Table<RowData>;
  sticky: boolean;
  disableHeader: boolean;
  hideHeader: boolean;
  hideLeftStickyShadow: boolean;
  hideRightStickyShadow: boolean;
  columnResizeDisabled: boolean;
  options?: FilterOptions;
  virtualizer?: Virtualizer<any, any>;
  tbody?: HTMLTableSectionElement | null;
  wrapperRef: RefObject<HTMLDivElement | null>;
}

export const TableStore = createStore<TableContextValue>();
export const useTableStoreValue = TableStore.useValue;
